import type { OptionsDocument, PresentationOption } from 'paintscout'
import { getPresentationOptions } from '../../../options/presentation/get-presentation-options'
import type { QuoteTypeOption } from '../../../options'
import find from 'lodash/find'

export function getInitialPresentation(args?: {
  options: OptionsDocument
  quoteType: QuoteTypeOption
}): PresentationOption {
  const { options, quoteType } = args
  const presentationOptions = getPresentationOptions({ options })

  const defaultPresentation = presentationOptions[0]

  // If quoteType has a default presentation attached use it, else
  if (quoteType?.defaultPresentation) {
    const p = find(presentationOptions, { key: quoteType.defaultPresentation })
    if (p) {
      return p
    }
  }

  // if user has a general default presentation, else use the first presentation(default)
  if (options.options.defaultPresentation) {
    const p = find(presentationOptions, { key: options.options.defaultPresentation })
    if (p) {
      return p
    }
  }

  return defaultPresentation
}
